import { createFileRoute } from '@tanstack/react-router';
import EntityProfileView from '@features/entities/EntityProfileView';

export const Route = createFileRoute('/w/entities/profile/$entityId')({
  staticData: { breadcrumb: 'Legal Entity Profile', breadcrumbKey: 'K_BREADCRUMB_ENTITY_PROFILE' },
  validateSearch: (search: Record<string, unknown>): { edit?: boolean } => {
    if (search.edit === true || search.edit === 'true') return { edit: true };
    return {};
  },
  component: EntityProfilePage,
});

function EntityProfilePage() {
  const { entityId } = Route.useParams();
  const { edit } = Route.useSearch();

  return (
    <EntityProfileView entityId={entityId} initialEdit={edit ?? false} />
  );
}
